import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import './AuthCallback.css';
import logo from '../Assets/LogoBlack.png';

// Create Supabase client - make sure these environment variables are set in your .env file
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL || '',
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '',
  {
    auth: {
      flowType: 'pkce'
    }
  }
);

const AuthCallback = () => {
  const [state, setState] = useState('loading'); // loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    handleCallback();
  }, []);

  const showError = (message) => {
    setState('error');
    setErrorMessage(message);
    
    // Close popup after showing error
    setTimeout(() => {
      if (window.opener) {
        window.close();
      }
    }, 4000);
  };

  const showSuccess = () => {
    setState('success');
    
    // Close popup after showing success
    setTimeout(() => {
      if (window.opener) {
        window.close();
      }
    }, 2000);
  };

  const handleCallback = async () => {
    console.log('✅ === AUTH CALLBACK PAGE LOADED ===');
    console.log('✅ Current URL:', window.location.href);
    console.log('✅ URL params:', new URLSearchParams(window.location.search).toString());
    console.log('✅ Window opener exists:', !!window.opener);

    try {
      console.log('Getting Supabase session...');
      const { data, error } = await supabase.auth.getSession();

      console.log('Session retrieval result:');
      console.log('- Full data object:', data);
      console.log('- Has session:', !!data?.session);
      console.log('- Has error:', !!error);

      const session = data?.session;

      if (error) {
        console.error('Error getting session:', error);
        showError('Authentication failed: ' + error.message);
        return;
      }

      if (session) {
        console.log('✓ Session object found!');
        console.log('Session type:', typeof session);
        console.log('Session keys:', Object.keys(session || {}));
        console.log('Session access_token exists:', !!session.access_token);

        showSuccess();

        // Notify parent window that auth was successful
        if (window.opener) {
          console.log('Sending AUTH_SUCCESS to parent window...');
          console.log('Message being sent:', { type: 'AUTH_SUCCESS', session: !!session });

          window.opener.postMessage({
            type: 'AUTH_SUCCESS',
            session: session
          }, window.location.origin);

          console.log('✓ AUTH_SUCCESS message sent to parent window');
        } else {
          console.error('No window.opener found - cannot send message to parent');
        }
      } else {
        console.error('✗ No session object found in data');
        showError('No authentication session found');
      }

    } catch (error) {
      console.error('CRITICAL ERROR in callback:', error);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      showError('An unexpected error occurred');
    }
  };

  return (
    <div className="auth-callback-wrapper">
      <section className="auth-callback-container">
        <div className="callback-card">
          {/* Logo */}
          <div className="callback-logo">
            <img src={logo} alt="nformed" className="img-fluid" />
          </div>

          {/* Loading State */}
          {state === 'loading' && (
            <div id="loadingState">
              <div className="spinner-container">
                <div className="spinner"></div>
              </div>
              <div className="callback-message">Completing authentication...</div>
              <div className="callback-submessage">Please wait while we process your login</div>
              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>
            </div>
          )}

          {/* Success State */}
          {state === 'success' && (
            <div id="successState">
              <div className="callback-icon success">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <div className="callback-message">Social Authentication Successful!</div>
              <div className="callback-submessage">Please wait while we process your login...</div>
            </div>
          )}

          {/* Error State */}
          {state === 'error' && (
            <div id="errorState">
              <div className="callback-icon error">
                <i className="bi bi-exclamation-triangle-fill"></i>
              </div>
              <div className="callback-message">Authentication Failed</div>
              <div className="callback-submessage">{errorMessage || 'Please try again or contact support if the problem persists.'}</div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AuthCallback;
